import { voiceMsgTypes } from "./voice.types";

export const setVoiceRecording = (isRecording) => ({
  type: voiceMsgTypes.SET_VOICE_RECORDING,
  payload: isRecording,
});

export const setRecordingAudio = (audio) => ({
  type: voiceMsgTypes.SET_RECORDING_AUDIO,
  payload: audio,
});

export const setAudioStream = (stream) => ({
  type: voiceMsgTypes.SET_AUDIO_STREAM,
  payload: stream,
});

export const resetVoiceRecordingData = () => ({
  type: voiceMsgTypes.RESET_VOICE_RECORDING_DATA,
});
